import * as React from "react";
import * as cn from "classnames";

export interface D3RawDomContainerProps {
    className?: string;
}

export interface D3RawDomChartRenderSettings {
    x: number;
    y: number;
    width: number;
    height: number;
    isFirstRender: boolean;
}

export abstract class D3RawDomContainer<TProps> extends React.Component<TProps & D3RawDomContainerProps> {
    private container: SVGSVGElement | undefined;

    render() {
        return (
            <svg
                width="100"
                height="100"
                className={cn(this.props.className)}
                ref={e => (this.container = e)}
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid meet"
            />
        );
    }

    abstract renderChart(element: SVGSVGElement, props: Readonly<TProps>, settings: D3RawDomChartRenderSettings): void;

    componentDidMount() {
        if (this.container) {
            this.renderChart(this.container, this.props, this.getChartRenderSettings(true));
        }
    }

    componentDidUpdate() {
        if (this.container) {
            this.renderChart(this.container, this.props, this.getChartRenderSettings(false));
        }
    }

    getChartRenderSettings(isFirstRender: boolean): D3RawDomChartRenderSettings {
        return {
            x: 0,
            y: 0,
            width: 100,
            height: 100,
            isFirstRender
        };
    }
}
